/* eslint-disable no-param-reassign */
import { notification } from 'antd';
import { randomBytes } from 'crypto';
import debug from 'debug';

import {
	GET_ITEMS_START,
	GET_ITEMS_SUCCESS,
	GET_ITEMS_FAIL,
	UPDATE_ITEM_START,
	UPDATE_ITEM_SUCCESS,
	UPDATE_ITEM_FAIL,
	DELETE_ITEM_START,
	DELETE_ITEM_SUCCESS,
	DELETE_ITEM_FAIL,
} from 'admin/constants';
import * as api from 'api';

const log = debug('app:actions:items');

export function getItems(categoryId) {
	return async dispatch => {
		try {
			dispatch({ type: GET_ITEMS_START });

			const result = await api.getItems({ categoryId });

			if (result.success) {
				dispatch({
					type: GET_ITEMS_SUCCESS,
					payload: result.data,
				});
			} else {
				dispatch({ type: GET_ITEMS_FAIL });
			}
		} catch (e) {
			dispatch({ type: GET_ITEMS_FAIL });
		}
	};
}

export function updateItem(categoryId, data) {
	return async (dispatch, getState) => {
		try {
			let { id } = data;
			const isCreateMode = !id;

			dispatch({ type: UPDATE_ITEM_START });

			if (isCreateMode) {
				id = randomBytes(16).toString('hex');
			}

			const payload = { ...data, id, categoryId };
			const result = await api.updateItem(payload);

			log('updateItem', payload);

			if (result.success) {
				notification.success({
					message: isCreateMode ? 'Created' : 'Updated',
					description: isCreateMode
						? `${data.title} has been successfuly created`
						: `${data.title} has been successfuly updated`,
				});
				dispatch({ type: UPDATE_ITEM_SUCCESS, payload: { ...data, id, categoryId } });
			} else {
				log('updateItem FAIL', { message: 'Error!', description: result.message });
				notification.error({ message: 'Error!', description: result.message });
				dispatch({ type: UPDATE_ITEM_FAIL });
			}
		} catch (e) {
			dispatch({ type: UPDATE_ITEM_FAIL });
		}
	};
}

export function deleteItem(data) {
	return async dispatch => {
		try {
			log('deleteJob data', data);
			dispatch({ type: DELETE_ITEM_START });

			const result = await api.deleteItem({ ...data });
			log('deleteItem result', result);

			if (result.success) {
				notification.success({
					message: 'Deleted',
					description: `${data.title} has been successfuly deleted`,
				});
				dispatch({ type: DELETE_ITEM_SUCCESS, payload: { ...data } });
			} else {
				notification.error({ message: 'Error!', description: result.message });
				dispatch({ type: DELETE_ITEM_FAIL });
			}
		} catch (e) {
			dispatch({ type: DELETE_ITEM_FAIL });
		}
	};
}
